
import React from "react";
import {
  Box,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  useColorModeValue,
  Heading,
  HStack,
  VStack,
  Text,
  Badge,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
} from "recharts";

/************************************  USER ACTIVITY SYNC  ************************************/
export const UserActivitySync = () => {
  const data = [
    { day: "Mon", syncs: 1200 },
    { day: "Tue", syncs: 980 },
    { day: "Wed", syncs: 1500 },
    { day: "Thu", syncs: 1700 },
    { day: "Fri", syncs: 900 },
    { day: "Sat", syncs: 400 },
    { day: "Sun", syncs: 650 },
  ];

  const bg     = useColorModeValue("white", "gray.800");
  const border = useColorModeValue("gray.100", "gray.700");

  return (
    <Box p={6} bg={bg} rounded="xl" border="1px" borderColor={border} shadow="sm">
      <Heading as="h3" size="md" mb={4}>User Activity Sync</Heading>
      <Box h="220px">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="day" />
            <YAxis />
            <Tooltip />
            <Line
              type="monotone"
              dataKey="syncs"
              stroke="#8b5cf6"
              strokeWidth={2}
              dot
            />
          </LineChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};
